import { useCallback, useState } from 'react';

export const useSelectedItemsValidation = (
  selected?: Record<string, Array<string>>,
  maxSelected: number = 3,
  minSelected: number = 1,
) => {
  const [selectedItems, setSelectedItems] = useState<Record<string, Array<string>>>(selected || {});

  const onCheckboxClick = (id: string, tabId: string) => {
    setSelectedItems((prev) => ({
      ...prev,
      [tabId]: prev[tabId]?.includes(id)
        ? [...prev[tabId].filter((i) => i !== id)]
        : prev[tabId]
          ? [...prev[tabId], id]
          : [id],
    }));
  };

  const isMaxSelected = (tabId: string) =>
    maxSelected ? selectedItems[tabId]?.length >= maxSelected : false;

  const isMinSelected = useCallback(
    (tabId: string) => selectedItems[tabId]?.length >= minSelected,
    [selectedItems, minSelected],
  );

  return { selectedItems, onCheckboxClick, isMaxSelected, isMinSelected };
};
